import { CampaignsService } from '../services';
import { useOfficeDiscountHistoryMutation } from './useOfficeDiscountHistoryMutation';

/**
 * Takes an applied promo code back from one office (GOTU-9821). On success the
 * office's history is invalidated, so the removed code leaves the tab.
 *
 * `mutate(campaignId, { onSuccess, onError })`. A code that was already
 * removed, or never held, is the same 204 as a real removal, so it succeeds
 * rather than erroring.
 */
export const useRemoveOfficePromoCode = (officeId) =>
  useOfficeDiscountHistoryMutation(
    officeId,
    (campaignId) => CampaignsService.removeOfficePromoCode(officeId, campaignId),
  );
